import { ContributionType } from '../generated/graphql'

export const ContributionColors = {
  PENDING: 'rgb(124, 124, 124)',
  [ContributionType.OwnerEdit]: 'rgb(111, 62, 244)',
  [ContributionType.Edit]: 'rgb(244, 179, 62)',
  [ContributionType.Inquiry]: 'rgb(109, 144, 247)',
  [ContributionType.Challenge]: 'rgb(202, 59, 126)',
}
